import React, { createContext, useContext, useMemo, useState } from 'react';

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

// Helpers
const parsePriceToCents = (priceString) => {
  // Accept numbers or strings like "$12.34" or "12.34"
  if (typeof priceString === 'number') return Math.round(priceString * 100);
  const cleaned = String(priceString).replace(/[^0-9.]/g, '');
  const cents = Math.round(parseFloat(cleaned || '0') * 100);
  return Number.isFinite(cents) ? cents : 0;
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]); // { id, name, unitAmount, quantity }

  const addItem = (name, priceString) => {
    const unitAmount = parsePriceToCents(priceString);
    const id = name; // use name as id for now
    setItems((prev) => {
      const existing = prev.find((p) => p.id === id);
      if (existing) {
        return prev.map((p) => (p.id === id ? { ...p, quantity: p.quantity + 1 } : p));
      }
      return [...prev, { id, name, unitAmount, quantity: 1 }];
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((p) => p.id !== id));

  const updateQty = (id, quantity) =>
    setItems((prev) => prev.map((p) => (p.id === id ? { ...p, quantity: Math.max(1, quantity) } : p)));

  const clearCart = () => setItems([]);

  const totalCents = useMemo(() => items.reduce((sum, i) => sum + i.unitAmount * i.quantity, 0), [items]);

  const value = {
    items,
    addItem,
    removeItem,
    updateQty,
    clearCart,
    totalCents,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export default CartContext;

